(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/onboarding/animations/assets/javascripts/animations/tweens/create-set-left-tween.js') >= 0) return;  svs.modules.push('/components/onboarding/animations/assets/javascripts/animations/tweens/create-set-left-tween.js');
"use strict";



const positions = svs.components.onboarding.slides.animations.positions;

const createSetLeftTween = el => gsap.set(el, {
  x: positions.outsideLeft
});
setGlobal('svs.components.onboarding.animations.tweens.createSetLeftTween', createSetLeftTween);

 })(window);